export const REFRESH_AREAS = 'REFRESH_AREAS';
export const ADD_AREA = 'ADD_AREA';
export const UPDATE_AREA = 'UPDATE_AREA';
export const DELETE_AREA = 'DELETE_AREA';
export const SET_SELECTED_AREA = 'SET_SELECTED_AREA';
